import React, { createContext, useContext, useState } from 'react'

export const FileContextDispatch = createContext();

const FileContext = ({children}) => {
  const [audioFile, setAudioFile] = useState("");
  const [textFile, setTextFile] = useState("");
  const [statistics, setStatistics] = useState();

  const selectAudioFileHandler = (file) => {
    setAudioFile(file);
  }

  const selectTextFileHandler = (file) => {
    setTextFile(file);
  }

  const resetFilesHandler = () => {
    setAudioFile("");
    setTextFile("");
  }

  const setStatisticsHandler = (stats) => {
    setStatistics(stats);
  }

  const resetStatisticsHandler = () => {
    setStatistics(null);
  }

  return (
    <FileContextDispatch.Provider value={[ audioFile, textFile, selectAudioFileHandler, selectTextFileHandler, resetFilesHandler, statistics, setStatisticsHandler, resetStatisticsHandler ]}>
        {children}
    </FileContextDispatch.Provider>
  )
}

export default FileContext;

export const useFileDispatch = () => useContext(FileContextDispatch)